import { createSearchServiceClient } from "~/api/apiClient";
import type { PDFSearchResult } from "~/indigo-components/src/components/InlinePDFViewer/PDFSearchBar";
import {
  recordSearchSelection,
  type SearchSelectionMetadata,
} from "~/services/searchSelection";

/** Search a reference PDF by filename and return matches in page order. */
export async function searchGeneralDocsByFilename(
  query: string,
  filename: string,
): Promise<PDFSearchResult> {
  const trimmed = query.trim();
  if (!trimmed) return { matches: [] };

  const hits = await searchViaApi(trimmed, filename);
  const sortedHits = [...hits].sort((a, b) => {
    if (a.start_page_number !== b.start_page_number) {
      return a.start_page_number - b.start_page_number;
    }
    return a.chunk_index - b.chunk_index;
  });
  return {
    matches: sortedHits.map((h) => ({
      page: h.start_page_number,
      onSelect: () => void recordSearchSelection(h.searchAudit, h.chunk_id),
    })),
  };
}

type PageHit = {
  start_page_number: number;
  chunk_index: number;
  chunk_id: string;
} & SearchSelectionMetadata;

async function searchViaApi(
  query: string,
  filename: string,
): Promise<PageHit[]> {
  const { data, error } = await createSearchServiceClient().POST(
    "/search/general-docs",
    { body: { query, filename } },
  );
  if (error || !data) throw new Error("Failed to search general docs");
  return data.items.map((item) => ({ ...item, searchAudit: data.audit }));
}
